import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.split.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.array.join.js";
export default {
  props: {
    // 多选
    multiple: {
      type: Boolean,
      default: false,
      required: false
    },
    // 是否序列为字符串
    stringify: {
      type: Boolean,
      default: false,
      required: false
    }
  },
  methods: {
    tryParseMultipleString: function tryParseMultipleString(value) {
      if (this.multiple) {
        // 最后总应该返回数组
        if (this._.isArray(value)) {
          return value;
        } else if (this.stringify && this._.isString(value)) {
          return value.split(',').filter(function (e) {
            return e !== '';
          }).map(Number);
        } else {
          return [value];
        }
      } else {
        // 最后总应该返回单个值
        if (this._.isArray(value)) {
          return value.join(',');
        } else {
          return value;
        }
      }
    },
    tryStringify: function tryStringify(value) {
      if (this._.isArray(value) && this.multiple && this.stringify) {
        return value.join(',');
      } else {
        return value;
      }
    }
  }
};